<template>
    <div class="home d-flex">
        <v-btn
            icon
            small
            color="#d35400"
            class="custom-date-time-picker"
            @click="toggleDateFilter"
        >
            <v-icon>mdi-calendar</v-icon>
        </v-btn>

        <v-container fluid class="d-flex flex-grow-1">
            <v-row dense class="d-flex flex-grow-1">
                <v-col cols="6">
                    <v-card
                        outlined
                        class="d-flex flex-column"
                        style="height: 100%"
                    >
                        <v-card-title
                            class="pt-2 pb-2"
                            style="border-bottom: 1px solid #404040"
                        >
                            <div class="text-left v-card-custom-title-left">
                                Taker
                            </div>
                            <div class="text-right v-card-custom-title-right">
                                <v-btn
                                    small
                                    text
                                    color="warning"
                                    @click="resetTakerFilter"
                                >
                                    {{ $t("lp.eodPosition.clearFilter") }}
                                </v-btn>
                            </div>
                        </v-card-title>

                        <v-data-table
                            class="flex-grow-1"
                            dense
                            :headers="takerHeader"
                            :items="takerData"
                            item-key="id"
                            :loading="takerLoading"
                            :loading-text="$t('lp.eodPosition.loadingText')"
                            :items-per-page="-1"
                            :height="tableHeight"
                            :hide-default-footer="true"
                            fixed-header
                            :header-props="{ sortIcon: null }"
                        >
                            <template v-slot:header.name="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="takerNameFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="takerFilters.name.length"
                                            >mdi-filter</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in takerNameFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            takerFilters.name.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeTakerFilterOptions(
                                                                option,
                                                                'name'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    takerNameFilterMenu = false
                                                "
                                                >OK</v-btn
                                            ><v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="takerFilters.name = []"
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:header.symbol="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="takerSymbolFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="takerFilters.symbol.length"
                                            >mdi-filter-outline</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in takerSymbolFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            takerFilters.symbol.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeTakerFilterOptions(
                                                                option,
                                                                'symbol'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    takerSymbolFilterMenu = false
                                                "
                                                >OK</v-btn
                                            >
                                            <v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="
                                                    takerFilters.symbol = []
                                                "
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:header.direction="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="takerDirectionFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="takerFilters.direction.length"
                                            >mdi-filter</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in takerDirectionFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            takerFilters.direction.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeTakerFilterOptions(
                                                                option,
                                                                'direction'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    takerDirectionFilterMenu = false
                                                "
                                                >OK</v-btn
                                            >
                                            <v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="
                                                    takerFilters.direction = []
                                                "
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:header.login="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="takerLoginFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="takerFilters.login.length"
                                            >mdi-filter</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in takerLoginFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            takerFilters.login.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeTakerFilterOptions(
                                                                option,
                                                                'login'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    takerLoginFilterMenu = false
                                                "
                                                >OK</v-btn
                                            >
                                            <v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="takerFilters.login = []"
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:header.connection="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="takerConnectionFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="
                                                takerFilters.connection.length
                                            "
                                            >mdi-filter</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in takerConnectionFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            takerFilters.connection.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeTakerFilterOptions(
                                                                option,
                                                                'connection'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    takerConnectionFilterMenu = false
                                                "
                                                >OK</v-btn
                                            >
                                            <v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="
                                                    takerFilters.connection = []
                                                "
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:item.volume="{ item }">
                                {{ parseFloat(item.volume).toFixed(2) }}
                            </template>
                            <template v-slot:item.name="{ item }">
                                <span :title="item.name">
                                    {{ truncate(item.name, 20) }}
                                </span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>

                <v-col cols="6">
                    <v-card
                        outlined
                        class="d-flex flex-column"
                        style="height: 100%"
                    >
                        <v-card-title
                            class="pt-2 pb-2"
                            style="border-bottom: 1px solid #404040"
                        >
                            <div class="text-left v-card-custom-title-left">
                                Maker
                            </div>
                            <div class="text-right v-card-custom-title-right">
                                <v-btn
                                    small
                                    text
                                    color="warning"
                                    @click="resetTakerFilter"
                                >
                                    {{ $t("lp.eodPosition.clearFilter") }}
                                </v-btn>
                            </div>
                        </v-card-title>

                        <v-data-table
                            class="flex-grow-1"
                            dense
                            :headers="makerHeader"
                            :items="makerData"
                            :loading="makerLoading"
                            :loading-text="$t('lp.eodPosition.loadingText')"
                            :items-per-page="-1"
                            :height="tableHeight"
                            :hide-default-footer="true"
                            fixed-header
                            :header-props="{ sortIcon: null }"
                        >
                            <template v-slot:header.name="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="makerNameFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="makerFilters.name.length"
                                            >mdi-filter</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in makerNameFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            makerFilters.name.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeMakerFilterOptions(
                                                                option,
                                                                'name'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    makerNameFilterMenu = false
                                                "
                                                >OK</v-btn
                                            ><v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="makerFilters.name = []"
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:header.symbol="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="makerSymbolFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="makerFilters.symbol.length"
                                            >mdi-filter-outline</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in makerSymbolFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            makerFilters.symbol.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeMakerFilterOptions(
                                                                option,
                                                                'symbol'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    makerSymbolFilterMenu = false
                                                "
                                                >OK</v-btn
                                            >
                                            <v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="
                                                    makerFilters.symbol = []
                                                "
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:header.direction="{ header }">
                                {{ header.text }}
                                <v-menu
                                    v-model="makerDirectionFilterMenu"
                                    offset-y
                                    :close-on-content-click="false"
                                    bottom
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-if="makerFilters.direction.length"
                                            >mdi-filter</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            v-else
                                            >mdi-filter-outline</v-icon
                                        >
                                    </template>

                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 220px;
                                        "
                                    >
                                        <v-list dense class="filterMenu">
                                            <v-list-item
                                                v-for="option in makerDirectionFilterOptions"
                                                :key="option"
                                            >
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        :input-value="
                                                            makerFilters.direction.includes(
                                                                option
                                                            )
                                                        "
                                                        @click.stop="
                                                            changeMakerFilterOptions(
                                                                option,
                                                                'direction'
                                                            )
                                                        "
                                                    />
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        option
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <div class="pa-2">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                @click="
                                                    makerDirectionFilterMenu = false
                                                "
                                                >OK</v-btn
                                            >
                                            <v-btn
                                                small
                                                text
                                                color="warning"
                                                @click="
                                                    makerFilters.direction = []
                                                "
                                                >{{ $t("lp.eodPosition.clearFilter") }}</v-btn
                                            >
                                        </div>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:item.volume="{ item }">
                                {{ parseFloat(item.volume).toFixed(2) }}
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="datePickerVisible" width="400" :hide-overlay="false">
            <v-card>
                <v-card-title class="text-h5">{{$t('alert.filterDates')}}</v-card-title>
                <v-card-text>{{ $t("lp.eodPosition.selectDateBelow") }}</v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" style="text-align: center">
                            <v-date-picker
                                v-model="recordDate"
                                :allowed-dates="allowedDates"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="fetchNewData">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { helper } from "@components/mixins/helper";
import { snackbar } from "@components/mixins/snackbar";
import { fetchMakerData, fetchTakerData } from "@services/lp/eod-position";
import common from "@assets/js/common";
import dayjs from "dayjs";

export default {
    mixins: [helper, snackbar],
    props: {
        tableHeight: Number,
    },
    data() {
        return {
            recordDate: common
                .getMT4TimeStringWithTimeDifference(-1, "day")
                .split(" ")[0],
            takerLoading: false,
            makerLoading: false,
            datePickerVisible: false,
            mt4Today: common.getMT4TimeString().split(" ")[0],

            takerHeader: [
                { text: this.$t("common.table.connection"), value: "connection", align: "left" },
                { text: this.$t("common.table.login"), value: "login", align: "left" },
                { text: this.$t("lp.name"), value: "name", align: "left" },
                { text: this.$t("common.table.symbol"), value: "symbol", align: "left" },
                { text: this.$t("common.table.direction"), value: "direction", align: "left" },
                { text: this.$t("common.table.takerMakerVolume"), value: "volume", align: "right" },
            ],
            makerHeader: [
                { text: "LP", value: "name", align: "left" },
                { text: this.$t("common.table.symbol"), value: "symbol", align: "left" },
                { text: this.$t("common.table.direction"), value: "direction", align: "left" },
                { text: this.$t("common.table.takerMakerVolume"), value: "volume", align: "right" },
            ],

            makerDataRaw: [],
            takerDataRaw: [],

            makerFilters: {
                name: [],
                symbol: [],
                direction: [],
            },

            takerFilters: {
                name: [],
                symbol: [],
                direction: [],
                login: [],
                connection: [],
            },

            makerNameFilterMenu: false,
            makerSymbolFilterMenu: false,
            makerDirectionFilterMenu: false,
            makerNameFilterOptions: [],
            makerSymbolFilterOptions: [],
            makerDirectionFilterOptions: [],

            takerNameFilterMenu: false,
            takerSymbolFilterMenu: false,
            takerDirectionFilterMenu: false,
            takerLoginFilterMenu: false,
            takerConnectionFilterMenu: false,
            takerNameFilterOptions: [],
            takerSymbolFilterOptions: [],
            takerDirectionFilterOptions: [],
            takerLoginFilterOptions: [],
            takerConnectionFilterOptions: [],
        };
    },
    computed: {
        makerData() {
            let filtered = [...this.makerDataRaw];

            if (this.makerFilters.name.length)
                filtered = filtered.filter((row) =>
                    this.makerFilters.name.includes(row.name)
                );

            if (this.makerFilters.symbol.length)
                filtered = filtered.filter((row) =>
                    this.makerFilters.symbol.includes(row.symbol)
                );

            if (this.makerFilters.direction.length)
                filtered = filtered.filter((row) =>
                    this.makerFilters.direction.includes(row.direction)
                );

            return filtered;
        },
        takerData() {
            let filtered = [...this.takerDataRaw];

            if (this.takerFilters.name.length)
                filtered = filtered.filter((row) =>
                    this.takerFilters.name.includes(row.name)
                );

            if (this.takerFilters.symbol.length)
                filtered = filtered.filter((row) =>
                    this.takerFilters.symbol.includes(row.symbol)
                );

            if (this.takerFilters.direction.length)
                filtered = filtered.filter((row) =>
                    this.takerFilters.direction.includes(row.direction)
                );

            if (this.takerFilters.login.length)
                filtered = filtered.filter((row) =>
                    this.takerFilters.login.includes(row.login)
                );

            if (this.takerFilters.connection.length)
                filtered = filtered.filter((row) =>
                    this.takerFilters.connection.includes(row.connection)
                );

            return filtered;
        },
    },
    methods: {
        toggleDateFilter() {
            this.datePickerVisible = true;
        },
        allowedDates(val) {
            return dayjs(val).isBefore(dayjs(this.mt4Today));
        },
        getTakerData() {
            this.takerLoading = true;
            const params = {
                selected_date: this.recordDate.replaceAll("-", "_"),
            };
            fetchTakerData(params)
                .then(({ data }) => {
                    this.takerDataRaw = data || [];

                    this.takerNameFilterOptions = [
                        ...new Set(data.map((i) => i.name)),
                    ];
                    this.takerSymbolFilterOptions = [
                        ...new Set(data.map((i) => i.symbol)),
                    ];
                    this.takerDirectionFilterOptions = [
                        ...new Set(data.map((i) => i.direction)),
                    ];
                    this.takerLoginFilterOptions = [
                        ...new Set(data.map((i) => i.login)),
                    ];
                    this.takerConnectionFilterOptions = [
                        ...new Set(data.map((i) => i.connection)),
                    ];
                })
                .finally(() => {
                    this.takerLoading = false;
                });
        },
        getMakerData() {
            this.makerLoading = true;
            const params = {
                selected_date: this.recordDate.replaceAll("-", "_"),
            };
            fetchMakerData(params)
                .then(({ data }) => {
                    this.makerDataRaw = data || [];

                    this.makerNameFilterOptions = [
                        ...new Set(data.map((i) => i.name)),
                    ];
                    this.makerSymbolFilterOptions = [
                        ...new Set(data.map((i) => i.symbol)),
                    ];
                    this.makerDirectionFilterOptions = [
                        ...new Set(data.map((i) => i.direction)),
                    ];
                })
                .finally(() => {
                    this.makerLoading = false;
                });
        },
        fetchNewData() {
            this.datePickerVisible = false;
            this.getMakerData();
            this.getTakerData();
        },
        truncate(text, length) {
            if (!text) return "";
            return text.length > length ? text.slice(0, length) + "…" : text;
        },
        changeMakerFilterOptions(option, type) {
            const current = this.makerFilters[type] || [];
            let updated;

            if (current.includes(option)) {
                updated = current.filter((item) => item !== option);
            } else {
                updated = [...current, option];
            }

            this.$set(this.makerFilters, type, updated);
        },
        changeTakerFilterOptions(option, type) {
            const current = this.takerFilters[type] || [];
            let updated;

            if (current.includes(option)) {
                updated = current.filter((item) => item !== option);
            } else {
                updated = [...current, option];
            }

            this.$set(this.takerFilters, type, updated);
        },
        resetTakerFilter() {
            this.takerFilters = {
                name: [],
                symbol: [],
                direction: [],
                login: [],
                connection: [],
            };
        },
        resetMakerFilter() {
            this.makerFilters = {
                name: [],
                symbol: [],
                direction: [],
            };
        },
    },
    created() {
        this.fetchNewData();
    },
};
</script>

<style>
.custom-date-time-picker {
    position: absolute;
    top: 30px;
    right: 20px;
}
.filterMenu {
    max-height: 500px;
    overflow-y: auto;
}
</style>
